//============================
//# mlgenpartprod
//============================

import { ValidationRules } from "@/models/Validation";
import { t } from "@/plugins/i18n";

export default interface PartProdRelation {
  id: number;
  partner: number;
  prodType: number;
  prodTypeName: string;
  region: number;
  regionName: string;
  isTax: boolean;
  partner2: number | null;
  taxId: number | null;
  prodNo: string;
  ocsgNo: string | null;
  taxNo: string;
  birthName: string | null;
  birthDate: Date | null;
  birthPlace: string | null;
  motherName: string | null;
  sex: boolean | null;
  sexName: string | null;
  tajNumber: string | null;
  nationality: string | null;
  felirNumber: string | null;
  nebihNumber: string | null;
  regNo: string | null;
  deleted: boolean;
  isProdTypeEditable: boolean;

  inEdit: boolean;
}

export const PartProdRelationDefaultProps: PartProdRelation = {
  id: 0,
  partner: 1,
  prodType: 1,
  prodTypeName: "-",
  region: 1,
  regionName: "-",
  isTax: false,
  partner2: null,
  taxId: null,
  prodNo: "-",
  ocsgNo: null,
  taxNo: "-",
  birthName: "-",
  birthDate: null,
  birthPlace: "-",
  motherName: "-",
  sex: null,
  sexName: null,
  tajNumber: null,
  nationality: "-",
  felirNumber: "-",
  nebihNumber: "-",
  regNo: null,
  deleted: false,
  isProdTypeEditable: false,

  inEdit: false,
}

export const PartProdRelationValidationRules: ValidationRules = {
  birthName: [
    (v: string) => !!v || t("Kotelezo"),
    (v: string) => v.replace(/\s+/g, "").length >= 4 || t("Partner_NemLehetRovidebbMint4Karakter"),
  ],
  motherName: [
    (v: string) => !!v || t("Kotelezo"),
    (v: string) => v.replace(/\s+/g, "").length >= 4 || t("Partner_NemLehetRovidebbMint4Karakter"),
  ],
  nationality: [
    (v: string) => !!v || t("Kotelezo"),
    (v: string) => v.replace(/\s+/g, "").length >= 2 || t("Partner_NemLehetRovidebbMint2Karakter"),
  ],
  prodNo: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^\\d{7}$").test(v)) || t("Partner_RosszFormatum1234567"),
  ],
  ocsgNo: [
    (v: string) => (v.length == 0 || new RegExp("^\\d{8}$").test(v)) || t("Partner_RosszFormatum12345678"),
  ],
  taxNo: [
    (v: string) => !!v || t("Kotelezo"),
    // (v: string) => new RegExp("^\\d{10}$").test(v) || "Rossz formátum (1234567890)",
  ],
  felirNumber: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^[A-Z]{2}\\d{7}$").test(v)) || t("Partner_RosszFormatumAB1234567"),
  ],
  nebihNumber: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^\\d{10}$").test(v)) || t("Partner_RosszFormatum1234567890"),
  ],
  tajNumber: [
    (v: string) => !!v || t("Kotelezo"),
    (v: string) => new RegExp("^\\d{9}$").test(v) || t("Partner_RosszFormatum123456789"),
 ],  
 regNo: [
    // (v: string) => !!v || "Kötelező",
    (v: string) => (v.length == 0 || new RegExp("^\\d{10}$").test(v)) || t("Partner_RosszFormatum1234567890"),
 ],
}